<template>
  <div>
    <job-search-card />
  </div>
</template>

<script>
import JobSearchCard from '#/ui/Components/JobSearchCard.vue';

export default {
  components: {
    JobSearchCard,
  },
};
</script>
